export default __webpack_public_path__ + "static/media/medium-line.7aa05141.svg";